mutation studentDataloadProcess(
  $id:                   ID!,
  $columnMapping:        StudentDataloadColumnMapping,
  $gradeLevelMappings:   [StudentDataloadGradeLevelMapping],
  $homeLanguageMappings: [StudentDataloadHomeLanguageMapping],
  $rowRejections:        [Integer],
  $worksheetIndex:       Integer!
) {
  studentDataloadProcess(
    id:                   $id,
    columnMapping:        $columnMapping,
    gradeLevelMappings:   $gradeLevelMappings,
    homeLanguageMappings: $homeLanguageMappings,
    rowRejections:        $rowRejections,
    worksheetIndex:       $worksheetIndex,
  ) {
    id
  }
}
